import { updateWorkSecuritySettings } from "services/work-security.service";
import { WorkSecuritySettings } from "types/WorkSecuritySettings";
import {
  TemplateSlotValue,
  resolveTemplateSource,
} from "../../template-slot-card";

/** What PATCH work-security-settings accepts. */
export type WorkSecurityRequest = Parameters<
  typeof updateWorkSecuritySettings
>[1];

export function roleSlotOf(entity: WorkSecuritySettings): TemplateSlotValue {
  return {
    source: resolveTemplateSource(
      entity.workSecurityRoleTemplateSource,
      entity.workSecurityRoleTemplate
    ),
    templateId: entity.workSecurityRoleTemplate || "",
    seriesId: entity.workSecurityRoleSeries || "",
    fileTypeId: entity.workSecurityRoleFileType || "",
    categoryId: entity.workSecurityRoleCategory || "",
  };
}

export function incidentActSlotOf(
  entity: WorkSecuritySettings
): TemplateSlotValue {
  return {
    source: resolveTemplateSource(
      entity.workSecurityIncidentActTemplateSource,
      entity.workSecurityIncidentActTemplate
    ),
    templateId: entity.workSecurityIncidentActTemplate || "",
    seriesId: entity.workSecurityIncidentActSeries || "",
    fileTypeId: entity.workSecurityIncidentActFileType || "",
    categoryId: entity.workSecurityIncidentActCategory || "",
  };
}

export function uploadFoldersOf(entity: WorkSecuritySettings): string[] {
  if (Array.isArray(entity.workSecurityRoleUploadCategories)) {
    return entity.workSecurityRoleUploadCategories.filter(Boolean);
  }
  return entity.workSecurityRoleUploadCategory
    ? [entity.workSecurityRoleUploadCategory]
    : [];
}

/** Everything the chosen source needs is picked: a system template needs series, type and folder; an own one a template and folder. */
export function isSlotComplete(slot: TemplateSlotValue): boolean {
  if (slot.source === "custom") {
    return Boolean(slot.templateId && slot.categoryId);
  }
  return Boolean(slot.seriesId && slot.fileTypeId && slot.categoryId);
}

export function roleSlotRequest(slot: TemplateSlotValue): WorkSecurityRequest {
  return {
    workSecurityRoleTemplateSource: slot.source,
    workSecurityRoleTemplate: slot.templateId,
    workSecurityRoleSeries: slot.seriesId,
    workSecurityRoleFileType: slot.fileTypeId,
    workSecurityRoleCategory: slot.categoryId,
  };
}

export function incidentActSlotRequest(
  slot: TemplateSlotValue
): WorkSecurityRequest {
  return {
    workSecurityIncidentActTemplateSource: slot.source,
    workSecurityIncidentActTemplate: slot.templateId,
    workSecurityIncidentActSeries: slot.seriesId,
    workSecurityIncidentActFileType: slot.fileTypeId,
    workSecurityIncidentActCategory: slot.categoryId,
  };
}
